/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobDeliverablesTab_stateTypes$ref: FragmentReference;
declare export opaque type JobDeliverablesTab_stateTypes$fragmentType: JobDeliverablesTab_stateTypes$ref;
export type JobDeliverablesTab_stateTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: JobDeliverablesTab_stateTypes$ref,
|};
export type JobDeliverablesTab_stateTypes$data = JobDeliverablesTab_stateTypes;
export type JobDeliverablesTab_stateTypes$key = {
  +$data?: JobDeliverablesTab_stateTypes$data,
  +$fragmentRefs: JobDeliverablesTab_stateTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "JobDeliverablesTab_stateTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f273b5b8a0dfd1bf1d5922a0251ad1bc';
module.exports = node;
